module.exports = __webpack_public_path__ + "img/face_shape_male_extra_heart_mask.b942276a.png";